module.exports = __webpack_public_path__ + "img/75668.82ebac97.svg";